import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { prefixUrl } from '../../utils/url.util';

export type EventqToggleTabVariant = 'default' | 'pill';

export interface EventqToggleTabItem {
  id: string;
  label: string;
  icon?: string;
  iconSrc?: string;
  badgeCount?: number;
}

@Component({
  selector: 'eventq-toggle-tab',
  imports: [MatIcon],
  templateUrl: './toggle-tab.html',
  styleUrl: './toggle-tab.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.eventq-toggle-tab-host--pill]': "variant() === 'pill'",
  },
})
export class EventqToggleTab {
  readonly items = input.required<EventqToggleTabItem[]>();
  readonly activeId = input.required<string>();
  readonly variant = input<EventqToggleTabVariant>('default');

  readonly activeIdChange = output<string>();

  iconStyle(iconSrc: string): string {
    return `url(${prefixUrl(iconSrc)})`;
  }
}
